import { render, staticRenderFns } from "./SmartAnimationIcon.vue?vue&type=template&id=22708bf6&"
import script from "./SmartAnimationIcon.vue?vue&type=script&lang=js&"
export * from "./SmartAnimationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports